var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({staticClass:"error-icon mt-1",attrs:{"small":""}},'v-icon',attrs,false),on),[_vm._v("mdi-help-circle-outline")])]}}])},_vm._l((_vm.errors),function(error){return _c('div',[_vm._v(_vm._s(error))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }